<template>
  <div id="app">
	<MyHead ref='head' v-if="!noHead && !is_channel"></MyHead>
	<div class="mind" ref='mind'>
		<router-view v-if="isRouterShow"></router-view>
	</div>
	<!-- foot -->
	
	<LoginDialog :LoginShow='loginShow'></LoginDialog>
	<Recharge  :DialogShow='dialogShow' :choseProduct='choseProduct'></Recharge>
	<BrowserTips :BrowserDialogShow='browserDialogShow'></BrowserTips>
  </div>
</template>

<script>
// import Vue from 'vue';
import {mapState} from 'vuex'
import MyHead from '@/components/head';
import LoginDialog from '@/components/login';
import Recharge from '@/components/Recharge';
import BrowserTips from '@/components/browserTips';

export default {
  name: 'app',
  components: {
    MyHead,LoginDialog,
		Recharge,BrowserTips,
  },
  data(){
		return{
			noHead:false,
			loginShow:false,  
			dialogShow:false,
			choseProduct:null,
			browserDialogShow:false,
			isIE:false,
			isRouterShow:true,
		}
  },
	computed: {
		...mapState({
			is_channel: (state) => state.is_channel,
		}),
	},
  created(){
		let that = this;
		that.noHead = window._isNoHead;
		const href = location.href
		if (href == 'https://bkypc.qiusanga.cn/index.html#/downloadP' || href == 'https://bkypc.qiusanga.cn/#/') {
			this.$router.push({
				name: 'downloadP',
				query: {
					channel: 'scb_official'
				}
			})
		}
  },
  mounted() {
		let that = this;

		// 登录
		that.$bus.$on('loginDialogShow',(val)=>{
			that.loginShow = val;
		})
		//头部更新数据
		that.$bus.$on('getLogin',()=>{
			that.$refs.head.getLoginInfo();
		})
		// 打开充值框  
		/* @
		参数1定义为 充值框的状态 boolean 值 /true为开启 false为关闭
		参数2定义为 打开时需要自动选取的充值套餐  object入值 为null时则默认选区 id为82 金额为68.8的套餐
		*/
		that.$bus.$on('RechargeDialogShow',(val,item)=>{
			if(item&&item!=null){
				that.choseProduct = item;
			}else{
				that.choseProduct = {
					id:82,
					product_price:'68.8'
				};
			}
			that.dialogShow = val;
			
		});

		that.$bus.$on('isIEShow',(val)=>{
			that.browserDialogShow = val;
		})
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  methods: {
		reload(){
			this.isShow = false 
			this.$nextTick(() => {
				this.isShow = true
			})
		}
  },
  watch:{
		'$route':function(){
			window.scrollTo(0,0)
		}
  }
}
</script>

<style lang='less'>
	@import '@/style/base.less';
</style>
<style lang="less">
// 滚动条样式
::-webkit-scrollbar {
    /*滚动条整体样式*/
    width : 10px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
}
::-webkit-scrollbar-thumb {
	/*滚动条里面小方块*/
	border-radius   : 10px;
	background-color: rgb(168,168,168);
	background-image: -webkit-linear-gradient(
		45deg,
		rgba(255, 255, 255, 0.2) 25%,
		transparent 25%,
		transparent 50%,
		rgba(255, 255, 255, 0.2) 50%,
		rgba(255, 255, 255, 0.2) 75%,
		transparent 75%,
		transparent
	);
}
::-webkit-scrollbar-track {
	/*滚动条里面轨道*/
	box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
	background   : #ededed;
	border-radius: 10px;
}
._code_wrap {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>

